import React from "react";

const Footer = (props) => {
  return (
    <>
      <h2>Update Your Information with UTLA</h2>
      <p>All Monroe UTLA updates are available at www.MonroeUTLA.com. If anybody has any questions, please contact us. Monroe UTLA Chair Leo Carson can be reached at <a href="mailto:lcarsondp@gmail.com">lcarsondp@gmail.com</a>. Monroe UTLA Vice Chair Denise Leonard can be reached at <a href="mailto:denise.leonard@me.com">denise.leonard@me.com</a>.</p>
        <p>
          Sincerely,
          <br />
          Glenn Sacks
          <br />
          UTLA Vice Chair at Monroe High School
          <br />
          (818) 470-8587
        </p>
    </>
  );
};

export default Footer;
